import React, {useCallback} from "react";

//helpers:
import {useTranslation} from "react-i18next";

export const NetgraphNavbarBadges = ({
    showSpeakersBadge,
    insightsOptions = [],
    selectedInsights,
    setSelectedInsights,
    className,
}) => {
    const {t} = useTranslation();

    const isActive = useCallback(
        (insightName = "") =>
            selectedInsights &&
            Array.isArray(selectedInsights) &&
            selectedInsights.some(ins => ins.name === insightName),
        [selectedInsights]
    );

    return (
        <div className="netgraph_badges_container">
            {insightsOptions.map((insight, i) => {
                const isDisabled = !!insight.disabled;

                return (
                    <span
                        key={i}
                        className={`badge badge-primary insight_badge_netgraph_navbar ${
                            isActive(insight?.name) ? "active" : ""
                        } ${isDisabled ? "d-none" : ""} ${className??''} ${insight.name}`}
                        onClick={() => setSelectedInsights([insight])}
                    >
                        {t(insight.name)}
                    </span>
                );
            })}
            {showSpeakersBadge ? (
                <span
                    className={`badge badge-primary insight_badge_netgraph_navbar ${
                        isActive("Speakers") ? "active" : ""
                    }`}
                    onClick={() =>
                        setSelectedInsights([
                            {
                                key: "speakers",
                                name: "Speakers",
                                disabled: 0,
                            },
                        ])
                    }
                >
                    {t("GENERAL.SPEAKER")}s
                </span>
            ) : null}
        </div>
    );
};
